import {Component} from 'react';

export default class Empty extends Component {

    render() {
        return this.props.children;
    }
}



// WEBPACK FOOTER //
// ./src/components/empty/index.js